export default __webpack_public_path__ + "static/media/success.45c797f2.png";